import { computed } from 'vue';
import { useStore } from 'vuex';

// TODO: Provide/inject
/**
 * Get page data from
 *
 * @returns {PageData}
 */
export function usePageData() {
  const store = useStore();
  const { pageData } = store.state;
  /** @type Context */
  const context = pageData?.navigation?.context; // TODO fix once wgl integrated
  const pageUtagData = computed(() => store.state.pageUtagData);

  return {
    categoryId: pageData?.categoryId,
    productId: pageData?.productId,
    product: pageData?.product,
    reviewsData: pageData?.reviewsData,
    user: pageData?.authData,
    productUrl: pageData?.product?.productUrl || '',
    topLevelCategoryID: pageData?.product?.identifier?.topLevelCategoryID || '',
    brandName: pageData?.product?.detail?.brand?.name || '',
    referrer: pageData?.referrer,
    isOrigin: pageData?.isOrigin,
    isSecondPDP: pageData?.isSecondPDP,
    killswitches: pageData?.product?.killswitches,
    experimentation: pageData?.experimentation,
    deviceType: pageData?.deviceType,
    customerState: pageData?.customerState,
    shoppingMode: pageData?.shoppingMode,
    pageUtagData,
    experimentIds: pageData?.experimentIds,
    experimentFlags: pageData?.experimentFlags,
    flags: pageData?.flags,
    topLevelCategoryFlags: pageData?.topLevelCategoryFlags,
    traits: pageData?.traits,
    ...context,
  };
}

export default {
  usePageData,
};
